import { createRouter as createTanstackRouter } from "@tanstack/react-router"

// Import the generated route tree
import { routeTree } from "./routeTree.gen"
import { NotFound } from "./components/NotFound"

import "./styles.css"

// Some MCP/OAuth client traffic lands here with a `?mcp_token=<JWT>` query
// param appended to the destination URL (sometimes doubled). It's a session
// token we never consume, and left in place it leaks into GA landing-page
// reports, Hotjar recordings, and shared/copied URLs — and mints duplicate
// URL variants for crawlers. Strip it before the router is constructed so
// neither the router's location (which Analytics reads for page_view paths)
// nor `window.location.href` ever carries it. replaceState keeps the visit:
// no reload, no extra history entry. (2026-06-11 SEO audit, action 7.)
function stripMcpTokenFromUrl() {
  if (typeof window === `undefined`) return
  const url = new URL(window.location.href)
  if (!url.searchParams.has(`mcp_token`)) return
  // The doubled `?mcp_token=…?mcp_token=…` variant parses as one param whose
  // value contains the second token, so a single delete clears both.
  url.searchParams.delete(`mcp_token`)
  window.history.replaceState(window.history.state, ``, url)
}

// Create a new router instance
export function getRouter() {
  stripMcpTokenFromUrl()
  return createTanstackRouter({
    routeTree,
    defaultPreload: `viewport`,
    scrollRestoration: true,
    // Any unmatched path (and any `throw notFound()` without a closer handler)
    // renders our branded 404 inside the root Outlet.
    defaultNotFoundComponent: NotFound,
  })
}
